module.exports = __webpack_public_path__ + "img/P150T_weapon_103.a06c6485.png";